export default {
    'general': {
        'versioning': 'Versioning',
        'dashboard': 'Dashboard',
        'email': 'Email',
        'username': 'Username',
        'name': 'Name',
        'password': 'Password',
        'actions': 'Actions',
        'login': 'Login',
        'logout': 'Logout',
        'no_results': 'No results',
        'success': 'Success',
        'warning': 'Warning',
        'remember_me': 'Remember me',
        'error': 'Error',
        'edit': 'Edit',
        'details': 'Details',
        'add': 'Add',
        'delete': 'Delete',
        'yes': 'Yes',
        'no': 'No',
        'cancel': 'Cancel',
        'back': 'Back',
        'image': 'Image',
        'filters': 'Filters',
        'remove_filters': 'Remove filters',
        'default': 'Default',
        'save': 'Save',
        'key': 'Key',
        'distribution_zone': 'Distribution zone',
        'preview': 'Preview',
        'icon': 'Icon',
        'last_edited': 'Last edited',
        'unknown': 'Unknown',
        'latest_version': 'Latest version',
        'change': 'Change',
        'unlimited': 'Unlimited',
        'from': 'From',
        'to': 'To',
        'date': 'Date',
        'profile': 'Profile',
        'custom': 'Custom'
    },
    'errors': {
        'generic_error': 'There was an error',
        'login': 'There was an error logging in',
        'logout': 'There was an error logging out',
        'incorrect_password': 'The old password is incorrect',
        'no_access': 'No access',
        'invalid_data': 'Invalid data received',
        'not_found': 'Data not found',
        'user_exist': 'User with this username already exists',
        'load_data': 'There was an error loading data',
        'on_upload_image': 'There was an error uploading images',
        'on_upload_file': 'There was an error uploading files',
        'on_publish': 'There was an error while publishing',
        'on_approve': 'There was an error while approving',
        'on_download': 'There was an error while downloading file',
        'on_add': 'There was an error adding',
        'on_edit': 'There was an error editing',
        'on_delete': 'There was an error deleting',
        'on_sort': 'There was an error sorting',
        'unauthorized': 'Unauthorized',
        'user_does_not_exist': 'User does not exists',
        'username_exists': 'This username already exists. Please use different username.',
        'failed_to_insert': 'Failed to insert',
        'file_to_big': 'File is to big',
        'missing_roles': 'Missing roles',
        'no_roles_selected': 'User must have at least one role selected',
        'fetching_data': 'Error fetching data',
        'deleting_default_data': 'Error deleting default data',
        'data_already_exists': 'Data already exists',
        'unable_to_retrieve_extension': 'Unable to retrieve extension',
        'role_exists': 'Role exists',
        'role_does_not_exist': 'role does not exists',
        'time_parser': {
            'invalid_character_error': 'Only numbers and {0} units are allowed.',
            'number': 'number',
            'unit': 'unit',
            'invalid_format_error': 'Units must be in form of',
            'duplicated_unit_error': 'The unit {0} is duplicated.',
            'example': '(example: 3d12h)'
        },
        'max_queue_time': 'Max time for queue excided. Please use shorter duration.',
        'queue_time_to_small': 'Queue time is to short. Use longer duration.'
    },
    'success': {
        'on_add': 'Successfully added',
        'on_edit': 'Successfully edited',
        'on_delete': 'Successfully deleted',
        'on_publish': 'Successfully published',
        'on_approve': 'Successfully approved',
        'on_sort': 'Successfully sorted',
        'on_change_password': 'The password has been successfully changed',
        'channel_package_activated': 'Channel package successfully activated',
        'channel_package_deactivated': 'Channel package successfully deactivated'
    },
    'confirmations': {
        'general': 'Are you sure you want to proceed?',
        'header': 'Are you sure',
        'delete_row': 'Are you sure you want to delete',
        'deactivate_row': 'Are you sure you want to deactivate',
        'publish': 'Are you sure you want to publish on',
        'approve': 'Are you sure you want to approve'
    },
    'table': {
        'no_data': 'No data to display',
        'press_enter_search': 'Press enter to search',
        'search': 'Search by',
        'select_option': 'Select option',
        'select_date': 'Select date',
        'select_range': 'Select range',
        'of': 'of'
    },
    'profile': {
        'profile': 'Profile',
        'edit_profile': 'Edit profile',
        'old_password': 'Old password',
        'new_password': 'New password',
        'confirm_password': 'Confirm password',
        'change_password_text': 'If password field is empty, password will not be changed.',
        'change_password': 'Change password'
    },
    'user': {
        'user': 'User | Users',
        'add': 'Add user',
        'edit': 'Edit user',
        'name': 'Name',
        'username': 'Username',
        'password': 'Password',
        'confirm_password': 'Confirm password',
        'cannot_edit_username': 'Username cannot be edited',
        'change_password': 'Change password',
        'new_password': 'New password'
    },
    'task': {
        'task': 'Task | Tasks',
        'add': 'Add task',
        'edit': 'Edit task',
        'time': 'Time',
        'message': 'Message',
        'work_period': 'Work period',
        'work_periods': {
            'working_hours': 'Working hours',
            'outside_working_hours': 'Outside working hours',
            'weekend_or_holiday': 'Weekend and holidays'
        },
        'work_period_mismatch': 'The chosen date and time falls in: {value}',
        'valid_units': 'Valid units: {value} (day, hour, minute).',
        'decimals_not_allowed': 'Decimals not allowed',
        'reformat_time': 'Reformat time',
        'invalid_character_error': 'Only numbers and \'d\', \'h\', \'m\' units are allowed.',
        'number': 'number',
        'unit': 'unit',
        'invalid_format_error': 'Unit must be in form of',
        'duplicated_unit_error': 'The unit {0} is duplicated.'
    },
    'task_type': {
        'task_type': 'Task type | Task types',
        'add': 'Add task type',
        'edit': 'Edit task type',
        'color': 'Color',
        'monthly_billing_breakpoint': 'Monthly billing breakpoint'
    },
    'customer': {
        'customer': 'Customer | Customers',
        'customer_name': 'Customer name'
    }
}
